import { isEmpty } from 'lodash';

const getReporterValue = ({ reporter }) => (!isEmpty(reporter) ? `@${reporter}` : 'deleted');

export default getReporterValue;
